<div class="sidebar-section" [style.background-color]="viewModel.cardAccentColor$ | async">
  <div
    *ngIf="data | sectionRowViewModelBasicMethod: 'getSidebarText' as text"
    class="sidebar-text"
    [style.color]="
      viewModel.cardStack$ | async | textColorBasedOnSectionHeaderBackgroundColor: (viewModel.cardAccentColor$ | async)
    "
    appPrintCardScaleDownText
    [maxHeightInPx]="28"
    [maxWidthInPx]="280"
    [startScalingAfterNMillisecondsAfterViewInit]="500"
    [transparentWhileScaling]="viewModel.viewingInLiveView$ | async">
    {{ text }}
  </div>
</div>

<div class="main-section">
  <div class="top-half-of-card">
    <div
      *ngIf="data | sectionRowViewModelBasicMethod: 'getRowTitle' as title"
      class="product-card-name"
      [style.color]="viewModel.headerTextColor$ | async">
      {{ title | trimSafely }}
    </div>

    @if (viewModel.hasPropertiesBasedOnPools$ | async) {
      <div class="info-row" [style.gap.rem]="0.5">
        @for (property of viewModel.propertiesBasedOnPools$ | async; track property.title) {
          <div class="property-container" [style.color]="viewModel.bodyTextColor$ | async">
            <div class="title">{{ property.title }}</div>
            <div class="value">
              {{ property.value }}
            </div>
          </div>
        }
      </div>
    }

    <div class="info-row" [style.gap.rem]="0.375">
      <div
        *ngIf="viewModel | getExpandedGridSize: (viewModel.spoofedColViewModel$ | async) : true | async as size"
        class="product-card-size"
        [style.color]="viewModel.bodyTextColor$ | async">
        {{ size }}
      </div>

      <app-label-inflator
        class="print-card-label"
        [columnLabel]="false"
        [labelComponentInterface]="data"
        [reset]="false">
      </app-label-inflator>

      <img
        *ngFor="let variantBadge of data | printCardBadges"
        appImage
        class="product-badge"
        [asset]="variantBadge?.image"
        alt="badge"
        src="" />
    </div>
  </div>
  <div class="bottom-half-of-card">
    <div>
      <img
        *ngIf="data | getVariantAssetForCard | async as variantAsset"
        appImage
        class="product-card-image"
        [asset]="variantAsset"
        src=""
        alt="" />
    </div>

    <app-nycd-index-price></app-nycd-index-price>
  </div>
</div>
